package pl.decks.chartjs.radar.options

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.mode.InteractionMode

data class InteractionOptions(
    val mode: InteractionMode = InteractionMode.Nearest,
    val intersect: Boolean = true,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.mode = mode.toChartJs()
        this.intersect = intersect.asDynamic()
    }
}
